import { createListStore } from "./list";
import { TasksService } from "@/services/tasks";

export const useTasksStore = createListStore("tasks", TasksService);
